module.exports = __webpack_public_path__ + "static/5-d7417e216f82e3ac0dd8aa019832b650.jpg";